module.exports = __webpack_public_path__ + "img/88_SetIcon_Rebel_Clash.5022d645.png";